import type { UpdatePortfolioSchema } from '@labi-api-libs/schemas'
import { httpClient } from '@/services/http/httpClient'

type UpdatePortfolioData = UpdatePortfolioSchema & { id: string }

type UpdatePortfolioResponse = {
  id: string
  title: string
  description: string
  tennantId: string
  ownerId: string
  createdAt: string
  updatedAt: string
}

export async function updatePortfolio({
  id,
  title,
  description,
}: UpdatePortfolioData): Promise<UpdatePortfolioResponse> {
  const { data } = await httpClient.put<UpdatePortfolioResponse>(
    `/projects/portfolios/${id}`,
    {
      title,
      description,
    },
  )

  return data
}
